import { render } from "./ButtonsEditor.vue?vue&type=template&id=7ca1ee66&scoped=true"
import script from "./ButtonsEditor.vue?vue&type=script&lang=js"
export * from "./ButtonsEditor.vue?vue&type=script&lang=js"

import "./ButtonsEditor.vue?vue&type=style&index=0&id=7ca1ee66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ca1ee66"

export default script